import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useConnectivity } from '../../hooks/useConnectivity';
import { analysisScreenHidden, analysisScreenShown } from '../../state/slice';
import SlowConnectionHint from '../SlowConnectionHint';

/**
 * Goes under a loading screen's spinner. When the connection is slow it shows the amber hint card,
 * which takes the place of the slow banner while this is mounted. Offline is left to the banner.
 */
function AnalysisConnectionNotice() {
    const dispatch = useDispatch();
    const { isSlow } = useConnectivity();

    useEffect(() => {
        dispatch(analysisScreenShown());
        return () => dispatch(analysisScreenHidden());
    }, [dispatch]);

    return isSlow ? <SlowConnectionHint /> : null;
}

export default AnalysisConnectionNotice;
